import { SearchResponse } from 'gql/autogen/SearchResponse';
import { DetailsResponse } from 'gql/autogen/DetailsResponse';
import { CalendarResponse } from 'gql/autogen/CalendarResponse';
import { AvailabilityResponse } from 'gql/autogen/AvailabilityResponse';
import { getDateInYmdFormat, getTodayDate } from 'core-framework/util/datetime/date';
import {
    ActivityGqlOperation,
    ApiBaseState,
    AvailabilityRequestProps,
    CalendarRequestProps,
    DetailsRequestProps,
    ReviewRequestProps,
    SearchRequestProps,
    SearchRequestType,
} from 'store/api/api.types';
import { addDays } from 'date-fns';
import { ReviewResponse } from 'gql/autogen/ReviewResponse';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';
import { SearchType } from 'gql/autogen/SearchType';

const TodayDate = getTodayDate();
const LatestPossibleDate = addDays(TodayDate, 30);
export const CuscoClientId = 2018;

export const extraOptions = {
    maxRetries: 2, // The value `maxRetries` is `0` based
};

export const DefaultApiBaseState: ApiBaseState = {
    isSuccess: false,
    isLoading: false,
    isError: false,
    error: { data: 'undefined', status: 0, isUnhandledError: false, name: 'undefined', operation: ActivityGqlOperation.search, message: 'undefined' },
};

export const DefaultRequestProps = {
    search: {
        searchType: SearchType.CITY,
        searchRequestType: SearchRequestType.DEFAULT,
        pagination: { size: 24, number: 1 },
        defaultSort: { code: SortCode.ActivitiesSsr, order: SortOrder.Descending },
    } as SearchRequestProps,
    details: {
        activityId: 0,
        loyaltySearchType: LoyaltySearchType.UNKNOWN,
    } as DetailsRequestProps,
    availability: {
        activityToken: '',
    } as AvailabilityRequestProps,
    calendar: {
        activityToken: '',
    } as CalendarRequestProps,
    review: {
        activityId: 0,
        pagination: { size: 5, number: 1 },
        sort: { code: SortCode.Default, order: SortOrder.Default },
        filters: { valueFilters: [], rangeFilters: [] },
    } as Required<ReviewRequestProps>,
};

export const EmptyResponseValues: Record<ActivityGqlOperation, SearchResponse | DetailsResponse | CalendarResponse | AvailabilityResponse | ReviewResponse> = {
    search: {
        isSuccess: true,
        result: {
            isCompleted: true,
            resultInfo: {
                totalActivities: 0,
                totalFilteredActivities: 0,
            },
            activities: [],
        },
    },
    details: {
        isSuccess: true,
        result: {
            isCompleted: true,
        },
    },
    availability: {
        isSuccess: true,
        result: {
            isCompleted: true,
        },
    },
    calendar: {
        isSuccess: true,
        result: {
            isCompleted: true,
            calendar: {
                startDate: getDateInYmdFormat(TodayDate),
                endDate: getDateInYmdFormat(LatestPossibleDate),
            },
        },
    },
    review: {
        isSuccess: true,
        result: {
            isCompleted: true,
            resultInfo: {
                totalReviews: 0,
            },
            reviews: [],
        },
    },
};
